import * as types from "./mutation-type";
import { API_STATES } from "@/helpers";
import { findIndex } from "lodash";

const mutations = {
  [types.GET_AVAILABILITIES_BEGIN](state) {
    state.availabilitiesGetState = API_STATES.REQUEST_PENDING;
  },
  [types.GET_AVAILABILITIES_SUCCESS](state, availabilities) {
    state.availabilitiesGetError = null;
    state.availabilities = availabilities;
    state.availabilitiesGetState = API_STATES.REQUEST_SUCCESS;
  },
  [types.GET_AVAILABILITIES_ERROR](state, err) {
    state.availabilitiesGetState = API_STATES.REQUEST_ERROR;
    state.availabilitiesGetError = err;
  },

  [types.DELETE_AVAILABILITY_BEGIN](state) {
    state.availabilityDeleteState = API_STATES.REQUEST_PENDING;
  },
  [types.DELETE_AVAILABILITY_SUCCESS](state) {
    state.availabilityDeleteError = null;
    state.availabilityDeleteState = API_STATES.REQUEST_SUCCESS;
  },
  [types.DELETE_AVAILABILITY_ERROR](state, err) {
    state.availabilityDeleteState = API_STATES.REQUEST_ERROR;
    state.availabilityDeleteError = err;
  },

  [types.CREATE_AVAILABILITY_BEGIN](state) {
    state.availabilityCreateState = API_STATES.REQUEST_PENDING
  },
  [types.CREATE_AVAILABILITY_SUCCESS](state, data) {
    state.availabilityCreateError = null
    state.availabilityCreateState = API_STATES.REQUEST_SUCCESS
    state.availability = data
  },
  [types.CREATE_AVAILABILITY_ERROR](state, err) {
    state.availabilityCreateState = API_STATES.REQUEST_ERROR;
    state.availabilityCreateError = err;
  },

  [types.UPDATE_AVAILABILITY_BEGIN](state) {
    state.availabilityUpdateState =  API_STATES.REQUEST_PENDING
  },
  [types.UPDATE_AVAILABILITY_SUCCESS](state, data) {
    state.availabilityUpdateError = null
    state.availability = data
    state.availabilityUpdateState = API_STATES.REQUEST_SUCCESS
  },
  [types.UPDATE_AVAILABILITY_ERROR](state, err) {
    state.availabilityUpdateState = API_STATES.REQUEST_ERROR
    state.availabilityUpdateError = err
  },

  //add availability schedule
  [types.ADD_AVAILABILITY_SCHEDULE_BEGIN](state) {
    state.addAvailabilityScheduleState = API_STATES.REQUEST_PENDING
  },
  [types.ADD_AVAILABILITY_SCHEDULE_SUCCESS](state, { rootState,data }) {
    state.addAvailabilityScheduleError = null
    state.availability = rootState.app.formData
    rootState.app.formData.availabilitySchedule.push(data)
    state.addAvailabilityScheduleState = API_STATES.REQUEST_SUCCESS
  },
  [types.ADD_AVAILABILITY_SCHEDULE_ERROR](state, err) {
    state.addAvailabilityScheduleState = API_STATES.REQUEST_ERROR;
    state.addAvailabilityScheduleError = err;
  },
  
  [types.DELETE_AVAILABILITY_SCHEDULE_BEGIN](state) {
    state.deleteAvailabilityScheduleState = API_STATES.REQUEST_PENDING
  },
  [types.DELETE_AVAILABILITY_SCHEDULE_SUCCESS](state, { rootState, id }) {
    state.availability = rootState.app.formData
    const index2 = findIndex(rootState.app.formData.availabilitySchedule, { id });
    rootState.app.formData.availabilitySchedule.splice(index2, 1)
    state.deleteAvailabilityScheduleState = API_STATES.REQUEST_SUCCESS
    state.deleteAvailabilityScheduleError = null
  },
  [types.DELETE_AVAILABILITY_SCHEDULE_ERROR](state, err) {
    state.deleteAvailabilityScheduleState = API_STATES.REQUEST_ERROR;
    state.deleteAvailabilityScheduleError = err;
  },
  
  [types.UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_BEGIN](state) {
    state.availabilityScheduleWeekDayUpdateState = API_STATES.REQUEST_PENDING;
  },
  [types.UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_SUCCESS](state){
    state.availabilityScheduleWeekDayState = API_STATES.REQUEST_SUCCESS;
    state.availabilityScheduleWeekDayUpdateError = null;
  },
  [types.UPDATE_AVAILABILITY_SCHEDULE_WEEKDAY_ERROR](state, err) {
    state.availabilityScheduleWeekDayState = API_STATES.REQUEST_ERROR;
    state.availabilityScheduleWeekDayUpdateError = err;
  },

  //Update from time
  [types.UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_BEGIN](state) {
    state.availabilityScheduleFromTimeUpdateState = API_STATES.REQUEST_PENDING;
  },
  [types.UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_SUCCESS](state, { rootState, updatedData }){
    state.availabilityScheduleFromTimeUpdateState = API_STATES.REQUEST_SUCCESS;
    rootState.app.formData.availabilitySchedule.find((f=>{
      if(f.id===updatedData.id){
        // eslint-disable-next-line camelcase
        f.from_time=updatedData.from_time
      }
    }))
  },
  [types.UPDATE_AVAILABILITY_SCHEDULE_FROM_TIME_ERROR](state, err) {
    state.availabilityScheduleFromTimeUpdateState = API_STATES.REQUEST_ERROR;
    state.availabilityScheduleFromTimeUpdateError = err;
  },

  //Update to time
  [types.UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_BEGIN](state) {
    state.availabilityScheduleToTimeUpdateState = API_STATES.REQUEST_PENDING;
  },
  [types.UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_SUCCESS](state, { rootState, updatedData }){
    state.availabilityScheduleToTimeUpdateState = API_STATES.REQUEST_SUCCESS;
    state.availabilityScheduleToTimeUpdateError = null;
    rootState.app.formData.availabilitySchedule.find((f=>{
      if(f.id===updatedData.id){
        // eslint-disable-next-line camelcase
        f.to_time=updatedData.to_time
      }
    }))
  },
  [types.UPDATE_AVAILABILITY_SCHEDULE_TO_TIME_ERROR](state, err) {
    state.availabilityScheduleToTimeUpdateState = API_STATES.REQUEST_ERROR;
    state.availabilityScheduleToTimeUpdateError = err;
  },
  
  //add user availability
  [types.ADD_USER_AVAILABILITY_TEMPLATE_BEGIN](state) {
    state.userAvailabilityCreateState = API_STATES.REQUEST_PENDING
  },
  [types.ADD_USER_AVAILABILITY_TEMPLATE_SUCCESS](state) {
    state.userAvailabilityCreateError = null
    state.userAvailabilityCreateState = API_STATES.REQUEST_SUCCESS
  },
  [types.ADD_USER_AVAILABILITY_TEMPLATE_ERROR](state, err) {
    state.userAvailabilityCreateState = API_STATES.REQUEST_ERROR;
    state.userAvailabilityCreateError = err;
  }
};

export default mutations;